<!-- 查询组件-->
<template>
  <div style="position: relative;">
    <div class="query_title">{{queryModel.title}}</div>
    <div class="query-wrapper">
    <el-form v-for="(item, index) in queryModel.queryFileds" :inline="true" :key="index">
      <el-form-item v-for="(filed, $index) in item" :label="filed.title" :key="$index">
        <!--filed.type 为标识-->
        <!--该列为input(filed.type为text)-->
        <el-input v-if="filed.type ==='text'" v-model="filed.value" :placeholder="filed.placeholder" :style="filed.style"></el-input>
        <el-autocomplete v-if="filed.type === 'auto_complete'" v-model="filed.value" :fetch-suggestions="handlerQuerySearchAsync" :placeholder="filed.placeholder" @select="handleSelect" :style="filed.style"></el-autocomplete>
        <!--该列为radio(filed.type为radio)-->
        <el-radio-group v-if="filed.type === 'radio'" v-model="filed.value">
          <el-radio v-for="(radio, index) in filed.options" :key="index" :label="radio.value">{{radio.label}}</el-radio>
        </el-radio-group>

        <el-checkbox-group v-model="filed.value" v-if="filed.type === 'checkbox'" :size="filed.size">
          <el-checkbox-button v-for="(radio, index) in filed.options" :key="index" :label="radio.value">{{radio.label}}</el-checkbox-button>
        </el-checkbox-group>
        <!--该列为select并且不分组(filed.type为select && filed.isGrouping为false)-->
        <el-select filterable :no-match-text="filed.noMatchText" :clearable="filed.clearable" :remote="filed.remote" :remote-method="handlerRemoteMethod" :style="filed.style" v-if="filed.type ==='select' && filed.isGrouping === false" v-model="filed.value" :placeholder="filed.placeholder" @change="ChangeSelect(filed)">
          <el-option v-if="filed.isHaveAll === true" :label='filed.allOptions.label' :value="filed.allOptions.value" :key="filed.allOptions.value">{{filed.allOptions.label}}</el-option>
          <el-option v-for="(option) in filed.options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
            >
          </el-option>
        </el-select>
        <!--该列为select且分组(filed.type为select && filed.isGrouping为true)-->
        <el-select filterable v-if="filed.type === 'select' && filed.isGrouping === true" v-model="filed.value" :placeholder="filed.placeholder">
          <el-option-group v-for="group in filed.options"
            :key="group.value"
            :label="group.label"
          >
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-option-group>
        </el-select>
        <!--该列为datetime, date(filed.type为datetime || date)-->
        <el-date-picker v-if="filed.type === 'datetime' || filed.type === 'date' || filed.type === 'daterange' || filed.type === 'datetimerange'"
          :type="filed.type"
          :placeholder="filed.placeholder"
          :value-format="filed.format"
          :start-placeholder="filed.StartPlaceholder"
          :end-placeholder="filed.endPlaceholder"
          :rang-separator="filed.separator"
          v-model="filed.value">
        </el-date-picker>
        <!--该列为有下划线的单选(filed.type为interval)-->
        <div v-if="filed.type === 'interval'" class="interval-container">
          <span v-for="item of filed.options" :key="item.key" @click="handlerInterval(filed, item)">{{item.label}}</span>
        </div>
      </el-form-item>
    </el-form>
    <slot>
    </slot>
    <div style="position: absolute;bottom: 0px; right: 0;">
      <el-form :inline="true">
        <el-form-item v-for="(button, index) in queryButton" :key="index">
          <el-button :type="button.type" :disabled="button.disabled" :size="button.size || 'medium'" @click="buttonClick(button)">{{button.label}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    </div>
  </div>
</template>

<script>
/*
  @author: zhengxiaobei
  @date: 2018/06/xx
  @desc: 查询组件
  @params
    props:
      queryModel: 查询组件的所有数据
      queryButton: 查询组件的按钮
    data:
      formData: 生成查询表单字段的数据源
      queryModelData: 将数组转化为对象
*/

import _ from 'lodash'

export default {
  name: 'w-query',
  props: {
    queryModel: Object,
    queryButton: Array
  },
  data () {
    return {
      formData: {},
      queryModelData: {},
      timer: null
    }
  },
  methods: {
    dealQueryData (fn) {
      Object.keys(this.queryModelData).map(fn)
    },
    initQueryModel () {
      _.map(this.queryModelData, (item, key) => {
        if (this.queryModelData[key]['type'] === 'checkbox') {
          this.queryModelData[key]['value'] = []
          this.formData[key] = []
        } else {
          this.queryModelData[key]['value'] = null
          this.formData[key] = null
        }
      })
    },
    buttonClick (button) {
      if (button.fn === 'searchAll') {
        this.initQueryModel()
      }
      this.$emit('buttonClick', this.formData, button)
    },
    ChangeSelect (filed) {
      if (filed.isChangeEvent) {
        if (filed.children) {
          this.queryModelData[filed.children]['value'] = null
        }
        this.$emit('changeSelect', filed)
      }
    },
    handlerInterval (filed, item) {
      // console.log('filed', filed)
      // console.log('item', item)
    },
    handlerRemoteMethod (query) {
      this.$emit('remoteMethod', query)
    },
    handlerQuerySearchAsync (queryString, cb) {
      this.$emit('querySearchAsync', queryString, cb)
    },
    handleSelect (params) {}
  },
  created () {
    this.queryModelData = this.queryModel.queryFileds.reduce((a, b) => Object.assign({}, a, b))
    delete this.queryModelData['value']
    this.dealQueryData(val => {
      let key = this.queryModelData[val].name
      if (this.queryModelData[val].value !== '' && this.queryModelData[val].value !== null) {
        this.formData[key] = this.queryModelData[val].value || null
      }
    })
  },
  computed: {
    param () {
      let data = {}
      this.dealQueryData(k => {
        let item = this.queryModelData[k]
        if (item.hasOwnProperty('name')) {
          data[item.name] = item.value
        }
      })
      return data
    }
  },
  watch: {
    param (n, o) {
      this.formData = this.param
    }
  }
}
</script>

<style lang="sass">
  .query_title
    margin-bottom: 10px
    color: #5F5F6E
    font-size: 16px
  .query-wrapper
    margin-bottom: 10px
  .interval-container
    span
      margin: 0 10px
      text-decoration: underline
      color: #1BCBB4
  .el-tag, .el-checkbox-button
    margin: 0!important
</style>



// WEBPACK FOOTER //
// src/components/base/query.vue